
interface City {
  name: string;
  slug: string;
}

export interface Country {
  name: string;
  code: string;
  topCities: City[];
}

// Top 50 cities combined from all countries for homepage display
export const topCitiesData: City[] = [
  { name: "New York", slug: "new-york" },
  { name: "London", slug: "london" },
  { name: "Paris", slug: "paris" },
  { name: "Tokyo", slug: "tokyo" },
  { name: "Los Angeles", slug: "los-angeles" },
  { name: "Madrid", slug: "madrid" },
  { name: "Barcelona", slug: "barcelona" },
  { name: "Toronto", slug: "toronto" },
  { name: "Sydney", slug: "sydney" },
  { name: "Berlin", slug: "berlin" },
  { name: "Chicago", slug: "chicago" },
  { name: "Amsterdam", slug: "amsterdam" },
  { name: "Milan", slug: "milan" },
  { name: "Vancouver", slug: "vancouver" },
  { name: "Singapore", slug: "singapore" },
  { name: "Dubai", slug: "dubai" },
  { name: "Boston", slug: "boston" },
  { name: "Miami", slug: "miami" },
  { name: "Vienna", slug: "vienna" },
  { name: "San Francisco", slug: "san-francisco" },
  { name: "Seoul", slug: "seoul" },
  { name: "Hong Kong", slug: "hong-kong" },
  { name: "Rome", slug: "rome" },
  { name: "Melbourne", slug: "melbourne" },
  { name: "Munich", slug: "munich" },
  { name: "Stockholm", slug: "stockholm" },
  { name: "Copenhagen", slug: "copenhagen" },
  { name: "Prague", slug: "prague" },
  { name: "Montreal", slug: "montreal" },
  { name: "Bangkok", slug: "bangkok" },
  { name: "Brussels", slug: "brussels" },
  { name: "Lisbon", slug: "lisbon" },
  { name: "Seattle", slug: "seattle" },
  { name: "Austin", slug: "austin" },
  { name: "Atlanta", slug: "atlanta" },
  { name: "Helsinki", slug: "helsinki" },
  { name: "Zurich", slug: "zurich" },
  { name: "Dublin", slug: "dublin" },
  { name: "Oslo", slug: "oslo" },
  { name: "Budapest", slug: "budapest" },
  { name: "Mexico City", slug: "mexico-city" },
  { name: "Buenos Aires", slug: "buenos-aires" },
  { name: "São Paulo", slug: "sao-paulo" },
  { name: "Istanbul", slug: "istanbul" },
  { name: "Athens", slug: "athens" },
  { name: "Warsaw", slug: "warsaw" },
  { name: "Edinburgh", slug: "edinburgh" },
  { name: "Valencia", slug: "valencia" },
  { name: "Seville", slug: "seville" },
  { name: "Beijing", slug: "beijing" }
];

export const countriesData: Country[] = [
  {
    name: "United States",
    code: "us",
    topCities: [
      { name: "New York", slug: "new-york" },
      { name: "Los Angeles", slug: "los-angeles" },
      { name: "Chicago", slug: "chicago" },
      { name: "San Francisco", slug: "san-francisco" },
      { name: "Boston", slug: "boston" },
      { name: "Miami", slug: "miami" },
      { name: "Seattle", slug: "seattle" },
      { name: "Austin", slug: "austin" },
      { name: "Atlanta", slug: "atlanta" },
      { name: "Denver", slug: "denver" },
      { name: "Washington DC", slug: "washington-dc" },
      { name: "Philadelphia", slug: "philadelphia" },
      { name: "Houston", slug: "houston" },
      { name: "Phoenix", slug: "phoenix" },
      { name: "San Diego", slug: "san-diego" }
    ]
  },
  {
    name: "United Kingdom",
    code: "uk",
    topCities: [
      { name: "London", slug: "london" },
      { name: "Manchester", slug: "manchester" },
      { name: "Edinburgh", slug: "edinburgh" },
      { name: "Birmingham", slug: "birmingham" },
      { name: "Glasgow", slug: "glasgow" },
      { name: "Liverpool", slug: "liverpool" },
      { name: "Bristol", slug: "bristol" },
      { name: "Leeds", slug: "leeds" },
      { name: "Sheffield", slug: "sheffield" },
      { name: "Newcastle", slug: "newcastle" },
      { name: "Belfast", slug: "belfast" },
      { name: "Cardiff", slug: "cardiff" },
      { name: "Nottingham", slug: "nottingham" },
      { name: "Southampton", slug: "southampton" },
      { name: "Oxford", slug: "oxford" }
    ]
  },
  {
    name: "Spain",
    code: "es",
    topCities: [
      { name: "Madrid", slug: "madrid" },
      { name: "Barcelona", slug: "barcelona" },
      { name: "Valencia", slug: "valencia" },
      { name: "Seville", slug: "seville" },
      { name: "Bilbao", slug: "bilbao" },
      { name: "Malaga", slug: "malaga" },
      { name: "Granada", slug: "granada" },
      { name: "Zaragoza", slug: "zaragoza" },
      { name: "Murcia", slug: "murcia" },
      { name: "Palma", slug: "palma" },
      { name: "Las Palmas", slug: "las-palmas" },
      { name: "A Coruña", slug: "a-coruna" },
      { name: "Alicante", slug: "alicante" },
      { name: "Córdoba", slug: "cordoba" },
      { name: "Valladolid", slug: "valladolid" }
    ]
  },
  {
    name: "France",
    code: "fr",
    topCities: [
      { name: "Paris", slug: "paris" },
      { name: "Lyon", slug: "lyon" },
      { name: "Marseille", slug: "marseille" },
      { name: "Bordeaux", slug: "bordeaux" },
      { name: "Nice", slug: "nice" },
      { name: "Toulouse", slug: "toulouse" },
      { name: "Strasbourg", slug: "strasbourg" },
      { name: "Nantes", slug: "nantes" },
      { name: "Montpellier", slug: "montpellier" },
      { name: "Lille", slug: "lille" },
      { name: "Rennes", slug: "rennes" },
      { name: "Reims", slug: "reims" },
      { name: "Saint-Étienne", slug: "saint-etienne" },
      { name: "Toulon", slug: "toulon" },
      { name: "Angers", slug: "angers" }
    ]
  },
  {
    name: "Germany",
    code: "de",
    topCities: [
      { name: "Berlin", slug: "berlin" },
      { name: "Munich", slug: "munich" },
      { name: "Hamburg", slug: "hamburg" },
      { name: "Frankfurt", slug: "frankfurt" },
      { name: "Cologne", slug: "cologne" },
      { name: "Stuttgart", slug: "stuttgart" },
      { name: "Düsseldorf", slug: "dusseldorf" },
      { name: "Dresden", slug: "dresden" },
      { name: "Leipzig", slug: "leipzig" },
      { name: "Hannover", slug: "hannover" },
      { name: "Nuremberg", slug: "nuremberg" },
      { name: "Bremen", slug: "bremen" },
      { name: "Bonn", slug: "bonn" },
      { name: "Münster", slug: "munster" },
      { name: "Karlsruhe", slug: "karlsruhe" }
    ]
  },
  {
    name: "Italy",
    code: "it",
    topCities: [
      { name: "Rome", slug: "rome" },
      { name: "Milan", slug: "milan" },
      { name: "Florence", slug: "florence" },
      { name: "Venice", slug: "venice" },
      { name: "Naples", slug: "naples" },
      { name: "Turin", slug: "turin" },
      { name: "Bologna", slug: "bologna" },
      { name: "Palermo", slug: "palermo" },
      { name: "Genoa", slug: "genoa" },
      { name: "Bari", slug: "bari" },
      { name: "Catania", slug: "catania" },
      { name: "Verona", slug: "verona" },
      { name: "Messina", slug: "messina" },
      { name: "Padua", slug: "padua" },
      { name: "Trieste", slug: "trieste" }
    ]
  },
  {
    name: "Canada",
    code: "ca",
    topCities: [
      { name: "Toronto", slug: "toronto" },
      { name: "Vancouver", slug: "vancouver" },
      { name: "Montreal", slug: "montreal" },
      { name: "Calgary", slug: "calgary" },
      { name: "Ottawa", slug: "ottawa" },
      { name: "Edmonton", slug: "edmonton" },
      { name: "Quebec City", slug: "quebec-city" },
      { name: "Winnipeg", slug: "winnipeg" },
      { name: "Hamilton", slug: "hamilton" },
      { name: "Halifax", slug: "halifax" },
      { name: "Victoria", slug: "victoria" },
      { name: "London (ON)", slug: "london-on" },
      { name: "Kitchener", slug: "kitchener" },
      { name: "St. John's", slug: "st-johns" },
      { name: "Saskatoon", slug: "saskatoon" }
    ]
  },
  {
    name: "Australia",
    code: "au",
    topCities: [
      { name: "Sydney", slug: "sydney" },
      { name: "Melbourne", slug: "melbourne" },
      { name: "Brisbane", slug: "brisbane" },
      { name: "Perth", slug: "perth" },
      { name: "Adelaide", slug: "adelaide" },
      { name: "Gold Coast", slug: "gold-coast" },
      { name: "Canberra", slug: "canberra" },
      { name: "Newcastle", slug: "newcastle-au" },
      { name: "Hobart", slug: "hobart" },
      { name: "Wollongong", slug: "wollongong" },
      { name: "Geelong", slug: "geelong" },
      { name: "Townsville", slug: "townsville" },
      { name: "Cairns", slug: "cairns" },
      { name: "Darwin", slug: "darwin" },
      { name: "Toowoomba", slug: "toowoomba" }
    ]
  },
  {
    name: "Japan",
    code: "jp",
    topCities: [
      { name: "Tokyo", slug: "tokyo" },
      { name: "Osaka", slug: "osaka" },
      { name: "Kyoto", slug: "kyoto" },
      { name: "Yokohama", slug: "yokohama" },
      { name: "Sapporo", slug: "sapporo" },
      { name: "Nagoya", slug: "nagoya" },
      { name: "Fukuoka", slug: "fukuoka" },
      { name: "Kobe", slug: "kobe" },
      { name: "Hiroshima", slug: "hiroshima" },
      { name: "Sendai", slug: "sendai" },
      { name: "Kawasaki", slug: "kawasaki" },
      { name: "Saitama", slug: "saitama" },
      { name: "Nara", slug: "nara" },
      { name: "Hakodate", slug: "hakodate" },
      { name: "Nagasaki", slug: "nagasaki" }
    ]
  },
  {
    name: "China",
    code: "cn",
    topCities: [
      { name: "Beijing", slug: "beijing" },
      { name: "Shanghai", slug: "shanghai" },
      { name: "Guangzhou", slug: "guangzhou" },
      { name: "Shenzhen", slug: "shenzhen" },
      { name: "Chengdu", slug: "chengdu" },
      { name: "Hangzhou", slug: "hangzhou" },
      { name: "Wuhan", slug: "wuhan" },
      { name: "Xi'an", slug: "xian" },
      { name: "Tianjin", slug: "tianjin" },
      { name: "Chongqing", slug: "chongqing" },
      { name: "Nanjing", slug: "nanjing" },
      { name: "Suzhou", slug: "suzhou" },
      { name: "Qingdao", slug: "qingdao" },
      { name: "Dalian", slug: "dalian" },
      { name: "Xiamen", slug: "xiamen" }
    ]
  },
  {
    name: "India",
    code: "in",
    topCities: [
      { name: "Mumbai", slug: "mumbai" },
      { name: "Delhi", slug: "delhi" },
      { name: "Bangalore", slug: "bangalore" },
      { name: "Hyderabad", slug: "hyderabad" },
      { name: "Chennai", slug: "chennai" },
      { name: "Kolkata", slug: "kolkata" },
      { name: "Pune", slug: "pune" },
      { name: "Ahmedabad", slug: "ahmedabad" },
      { name: "Jaipur", slug: "jaipur" },
      { name: "Lucknow", slug: "lucknow" },
      { name: "Chandigarh", slug: "chandigarh" },
      { name: "Kochi", slug: "kochi" },
      { name: "Goa", slug: "goa" },
      { name: "Indore", slug: "indore" },
      { name: "Surat", slug: "surat" }
    ]
  },
  {
    name: "Brazil",
    code: "br",
    topCities: [
      { name: "São Paulo", slug: "sao-paulo" },
      { name: "Rio de Janeiro", slug: "rio-de-janeiro" },
      { name: "Brasília", slug: "brasilia" },
      { name: "Salvador", slug: "salvador" },
      { name: "Fortaleza", slug: "fortaleza" },
      { name: "Belo Horizonte", slug: "belo-horizonte" },
      { name: "Manaus", slug: "manaus" },
      { name: "Curitiba", slug: "curitiba" },
      { name: "Recife", slug: "recife" },
      { name: "Porto Alegre", slug: "porto-alegre" },
      { name: "Belém", slug: "belem" },
      { name: "Goiânia", slug: "goiania" },
      { name: "Florianópolis", slug: "florianopolis" },
      { name: "Natal", slug: "natal" },
      { name: "João Pessoa", slug: "joao-pessoa" }
    ]
  },
  {
    name: "Russia",
    code: "ru",
    topCities: [
      { name: "Moscow", slug: "moscow" },
      { name: "Saint Petersburg", slug: "saint-petersburg" },
      { name: "Novosibirsk", slug: "novosibirsk" },
      { name: "Yekaterinburg", slug: "yekaterinburg" },
      { name: "Kazan", slug: "kazan" },
      { name: "Nizhny Novgorod", slug: "nizhny-novgorod" },
      { name: "Samara", slug: "samara" },
      { name: "Omsk", slug: "omsk" },
      { name: "Rostov-on-Don", slug: "rostov-on-don" },
      { name: "Chelyabinsk", slug: "chelyabinsk" },
      { name: "Ufa", slug: "ufa" },
      { name: "Volgograd", slug: "volgograd" },
      { name: "Perm", slug: "perm" },
      { name: "Krasnoyarsk", slug: "krasnoyarsk" },
      { name: "Sochi", slug: "sochi" }
    ]
  },
  {
    name: "Mexico",
    code: "mx",
    topCities: [
      { name: "Mexico City", slug: "mexico-city" },
      { name: "Guadalajara", slug: "guadalajara" },
      { name: "Monterrey", slug: "monterrey" },
      { name: "Puebla", slug: "puebla" },
      { name: "Tijuana", slug: "tijuana" },
      { name: "Cancún", slug: "cancun" },
      { name: "Mérida", slug: "merida" },
      { name: "León", slug: "leon" },
      { name: "Querétaro", slug: "queretaro" },
      { name: "Oaxaca", slug: "oaxaca" },
      { name: "San Miguel de Allende", slug: "san-miguel-de-allende" },
      { name: "Puerto Vallarta", slug: "puerto-vallarta" },
      { name: "Acapulco", slug: "acapulco" },
      { name: "Chihuahua", slug: "chihuahua" },
      { name: "Veracruz", slug: "veracruz" }
    ]
  },
  {
    name: "South Korea",
    code: "kr",
    topCities: [
      { name: "Seoul", slug: "seoul" },
      { name: "Busan", slug: "busan" },
      { name: "Incheon", slug: "incheon" },
      { name: "Daegu", slug: "daegu" },
      { name: "Daejeon", slug: "daejeon" },
      { name: "Gwangju", slug: "gwangju" },
      { name: "Suwon", slug: "suwon" },
      { name: "Ulsan", slug: "ulsan" },
      { name: "Seongnam", slug: "seongnam" },
      { name: "Goyang", slug: "goyang" },
      { name: "Changwon", slug: "changwon" },
      { name: "Jeju", slug: "jeju" },
      { name: "Anyang", slug: "anyang" },
      { name: "Bucheon", slug: "bucheon" },
      { name: "Cheongju", slug: "cheongju" }
    ]
  },
  {
    name: "Indonesia",
    code: "id",
    topCities: [
      { name: "Jakarta", slug: "jakarta" },
      { name: "Surabaya", slug: "surabaya" },
      { name: "Bandung", slug: "bandung" },
      { name: "Medan", slug: "medan" },
      { name: "Semarang", slug: "semarang" },
      { name: "Makassar", slug: "makassar" },
      { name: "Denpasar", slug: "denpasar" },
      { name: "Yogyakarta", slug: "yogyakarta" },
      { name: "Palembang", slug: "palembang" },
      { name: "Balikpapan", slug: "balikpapan" },
      { name: "Batam", slug: "batam" },
      { name: "Manado", slug: "manado" },
      { name: "Padang", slug: "padang" },
      { name: "Pontianak", slug: "pontianak" },
      { name: "Malang", slug: "malang" }
    ]
  },
  {
    name: "Netherlands",
    code: "nl",
    topCities: [
      { name: "Amsterdam", slug: "amsterdam" },
      { name: "Rotterdam", slug: "rotterdam" },
      { name: "The Hague", slug: "the-hague" },
      { name: "Utrecht", slug: "utrecht" },
      { name: "Eindhoven", slug: "eindhoven" },
      { name: "Groningen", slug: "groningen" },
      { name: "Tilburg", slug: "tilburg" },
      { name: "Almere", slug: "almere" },
      { name: "Breda", slug: "breda" },
      { name: "Nijmegen", slug: "nijmegen" },
      { name: "Enschede", slug: "enschede" },
      { name: "Haarlem", slug: "haarlem" },
      { name: "Arnhem", slug: "arnhem" },
      { name: "Leiden", slug: "leiden" },
      { name: "Maastricht", slug: "maastricht" }
    ]
  },
  {
    name: "Turkey",
    code: "tr",
    topCities: [
      { name: "Istanbul", slug: "istanbul" },
      { name: "Ankara", slug: "ankara" },
      { name: "Izmir", slug: "izmir" },
      { name: "Antalya", slug: "antalya" },
      { name: "Bursa", slug: "bursa" },
      { name: "Adana", slug: "adana" },
      { name: "Gaziantep", slug: "gaziantep" },
      { name: "Konya", slug: "konya" },
      { name: "Mersin", slug: "mersin" },
      { name: "Diyarbakır", slug: "diyarbakir" },
      { name: "Bodrum", slug: "bodrum" },
      { name: "Fethiye", slug: "fethiye" },
      { name: "Trabzon", slug: "trabzon" },
      { name: "Eskişehir", slug: "eskisehir" },
      { name: "Kayseri", slug: "kayseri" }
    ]
  },
  {
    name: "Poland",
    code: "pl",
    topCities: [
      { name: "Warsaw", slug: "warsaw" },
      { name: "Krakow", slug: "krakow" },
      { name: "Lodz", slug: "lodz" },
      { name: "Wroclaw", slug: "wroclaw" },
      { name: "Poznan", slug: "poznan" },
      { name: "Gdansk", slug: "gdansk" },
      { name: "Szczecin", slug: "szczecin" },
      { name: "Bydgoszcz", slug: "bydgoszcz" },
      { name: "Lublin", slug: "lublin" },
      { name: "Katowice", slug: "katowice" },
      { name: "Bialystok", slug: "bialystok" },
      { name: "Gdynia", slug: "gdynia" },
      { name: "Czestochowa", slug: "czestochowa" },
      { name: "Radom", slug: "radom" },
      { name: "Torun", slug: "torun" }
    ]
  },
  {
    name: "Argentina",
    code: "ar",
    topCities: [
      { name: "Buenos Aires", slug: "buenos-aires" },
      { name: "Córdoba", slug: "cordoba-ar" },
      { name: "Rosario", slug: "rosario" },
      { name: "Mendoza", slug: "mendoza" },
      { name: "La Plata", slug: "la-plata" },
      { name: "San Miguel de Tucumán", slug: "tucuman" },
      { name: "Mar del Plata", slug: "mar-del-plata" },
      { name: "Salta", slug: "salta" },
      { name: "Santa Fe", slug: "santa-fe" },
      { name: "San Juan", slug: "san-juan" },
      { name: "Resistencia", slug: "resistencia" },
      { name: "Posadas", slug: "posadas" },
      { name: "Bariloche", slug: "bariloche" },
      { name: "Neuquén", slug: "neuquen" },
      { name: "Bahía Blanca", slug: "bahia-blanca" }
    ]
  },
  {
    name: "Sweden",
    code: "se",
    topCities: [
      { name: "Stockholm", slug: "stockholm" },
      { name: "Gothenburg", slug: "gothenburg" },
      { name: "Malmö", slug: "malmo" },
      { name: "Uppsala", slug: "uppsala" },
      { name: "Västerås", slug: "vasteras" },
      { name: "Örebro", slug: "orebro" },
      { name: "Linköping", slug: "linkoping" },
      { name: "Helsingborg", slug: "helsingborg" },
      { name: "Jönköping", slug: "jonkoping" },
      { name: "Norrköping", slug: "norrkoping" },
      { name: "Umeå", slug: "umea" },
      { name: "Lund", slug: "lund" },
      { name: "Borås", slug: "boras" },
      { name: "Gävle", slug: "gavle" },
      { name: "Södertälje", slug: "sodertalje" }
    ]
  },
  {
    name: "Norway",
    code: "no",
    topCities: [
      { name: "Oslo", slug: "oslo" },
      { name: "Bergen", slug: "bergen" },
      { name: "Trondheim", slug: "trondheim" },
      { name: "Stavanger", slug: "stavanger" },
      { name: "Drammen", slug: "drammen" },
      { name: "Fredrikstad", slug: "fredrikstad" },
      { name: "Kristiansand", slug: "kristiansand" },
      { name: "Tromsø", slug: "tromso" },
      { name: "Sandnes", slug: "sandnes" },
      { name: "Ålesund", slug: "alesund" },
      { name: "Tønsberg", slug: "tonsberg" },
      { name: "Bodø", slug: "bodo" },
      { name: "Sandefjord", slug: "sandefjord" },
      { name: "Moss", slug: "moss" },
      { name: "Haugesund", slug: "haugesund" }
    ]
  },
  {
    name: "Denmark",
    code: "dk",
    topCities: [
      { name: "Copenhagen", slug: "copenhagen" },
      { name: "Aarhus", slug: "aarhus" },
      { name: "Odense", slug: "odense" },
      { name: "Aalborg", slug: "aalborg" },
      { name: "Esbjerg", slug: "esbjerg" },
      { name: "Randers", slug: "randers" },
      { name: "Kolding", slug: "kolding" },
      { name: "Horsens", slug: "horsens" },
      { name: "Vejle", slug: "vejle" },
      { name: "Roskilde", slug: "roskilde" },
      { name: "Herning", slug: "herning" },
      { name: "Hørsholm", slug: "horsholm" },
      { name: "Silkeborg", slug: "silkeborg" },
      { name: "Næstved", slug: "naestved" },
      { name: "Fredericia", slug: "fredericia" }
    ]
  },
  {
    name: "Finland",
    code: "fi",
    topCities: [
      { name: "Helsinki", slug: "helsinki" },
      { name: "Espoo", slug: "espoo" },
      { name: "Tampere", slug: "tampere" },
      { name: "Vantaa", slug: "vantaa" },
      { name: "Oulu", slug: "oulu" },
      { name: "Turku", slug: "turku" },
      { name: "Jyväskylä", slug: "jyvaskyla" },
      { name: "Lahti", slug: "lahti" },
      { name: "Kuopio", slug: "kuopio" },
      { name: "Pori", slug: "pori" },
      { name: "Kouvola", slug: "kouvola" },
      { name: "Joensuu", slug: "joensuu" },
      { name: "Lappeenranta", slug: "lappeenranta" },
      { name: "Vaasa", slug: "vaasa" },
      { name: "Hämeenlinna", slug: "hameenlinna" }
    ]
  },
  {
    name: "Belgium",
    code: "be",
    topCities: [
      { name: "Brussels", slug: "brussels" },
      { name: "Antwerp", slug: "antwerp" },
      { name: "Ghent", slug: "ghent" },
      { name: "Bruges", slug: "bruges" },
      { name: "Leuven", slug: "leuven" },
      { name: "Liège", slug: "liege" },
      { name: "Charleroi", slug: "charleroi" },
      { name: "Namur", slug: "namur" },
      { name: "Mons", slug: "mons" },
      { name: "Mechelen", slug: "mechelen" },
      { name: "Aalst", slug: "aalst" },
      { name: "Hasselt", slug: "hasselt" },
      { name: "Kortrijk", slug: "kortrijk" },
      { name: "Ostend", slug: "ostend" },
      { name: "Tournai", slug: "tournai" }
    ]
  },
  {
    name: "Switzerland",
    code: "ch",
    topCities: [
      { name: "Zurich", slug: "zurich" },
      { name: "Geneva", slug: "geneva" },
      { name: "Basel", slug: "basel" },
      { name: "Bern", slug: "bern" },
      { name: "Lausanne", slug: "lausanne" },
      { name: "Lucerne", slug: "lucerne" },
      { name: "Winterthur", slug: "winterthur" },
      { name: "St. Gallen", slug: "st-gallen" },
      { name: "Lugano", slug: "lugano" },
      { name: "Biel", slug: "biel" },
      { name: "Thun", slug: "thun" },
      { name: "Bellinzona", slug: "bellinzona" },
      { name: "Fribourg", slug: "fribourg" },
      { name: "Montreux", slug: "montreux" },
      { name: "Neuchâtel", slug: "neuchatel" }
    ]
  },
  {
    name: "Austria",
    code: "at",
    topCities: [
      { name: "Vienna", slug: "vienna" },
      { name: "Graz", slug: "graz" },
      { name: "Linz", slug: "linz" },
      { name: "Salzburg", slug: "salzburg" },
      { name: "Innsbruck", slug: "innsbruck" },
      { name: "Klagenfurt", slug: "klagenfurt" },
      { name: "Villach", slug: "villach" },
      { name: "Wels", slug: "wels" },
      { name: "St. Pölten", slug: "st-polten" },
      { name: "Dornbirn", slug: "dornbirn" },
      { name: "Wiener Neustadt", slug: "wiener-neustadt" },
      { name: "Steyr", slug: "steyr" },
      { name: "Feldkirch", slug: "feldkirch" },
      { name: "Bregenz", slug: "bregenz" },
      { name: "Baden", slug: "baden-at" }
    ]
  },
  {
    name: "Portugal",
    code: "pt",
    topCities: [
      { name: "Lisbon", slug: "lisbon" },
      { name: "Porto", slug: "porto" },
      { name: "Braga", slug: "braga" },
      { name: "Coimbra", slug: "coimbra" },
      { name: "Faro", slug: "faro" },
      { name: "Amadora", slug: "amadora" },
      { name: "Setúbal", slug: "setubal" },
      { name: "Funchal", slug: "funchal" },
      { name: "Évora", slug: "evora" },
      { name: "Aveiro", slug: "aveiro" },
      { name: "Viseu", slug: "viseu" },
      { name: "Guimarães", slug: "guimaraes" },
      { name: "Leiria", slug: "leiria" },
      { name: "Lagos", slug: "lagos" },
      { name: "Albufeira", slug: "albufeira" }
    ]
  },
  {
    name: "Greece",
    code: "gr",
    topCities: [
      { name: "Athens", slug: "athens" },
      { name: "Thessaloniki", slug: "thessaloniki" },
      { name: "Patras", slug: "patras" },
      { name: "Heraklion", slug: "heraklion" },
      { name: "Larissa", slug: "larissa" },
      { name: "Volos", slug: "volos" },
      { name: "Rhodes", slug: "rhodes" },
      { name: "Ioannina", slug: "ioannina" },
      { name: "Chania", slug: "chania" },
      { name: "Corfu", slug: "corfu" },
      { name: "Kalamata", slug: "kalamata" },
      { name: "Santorini", slug: "santorini" },
      { name: "Mykonos", slug: "mykonos" },
      { name: "Kavala", slug: "kavala" },
      { name: "Alexandroupoli", slug: "alexandroupoli" }
    ]
  },
  {
    name: "Ireland",
    code: "ie",
    topCities: [
      { name: "Dublin", slug: "dublin" },
      { name: "Cork", slug: "cork" },
      { name: "Galway", slug: "galway" },
      { name: "Limerick", slug: "limerick" },
      { name: "Waterford", slug: "waterford" },
      { name: "Drogheda", slug: "drogheda" },
      { name: "Dundalk", slug: "dundalk" },
      { name: "Swords", slug: "swords" },
      { name: "Bray", slug: "bray" },
      { name: "Navan", slug: "navan" },
      { name: "Kilkenny", slug: "kilkenny" },
      { name: "Ennis", slug: "ennis" },
      { name: "Carlow", slug: "carlow" },
      { name: "Tralee", slug: "tralee" },
      { name: "Wexford", slug: "wexford" }
    ]
  },
  {
    name: "Hungary",
    code: "hu",
    topCities: [
      { name: "Budapest", slug: "budapest" },
      { name: "Debrecen", slug: "debrecen" },
      { name: "Szeged", slug: "szeged" },
      { name: "Miskolc", slug: "miskolc" },
      { name: "Pécs", slug: "pecs" },
      { name: "Győr", slug: "gyor" },
      { name: "Nyíregyháza", slug: "nyiregyhaza" },
      { name: "Kecskemét", slug: "kecskemet" },
      { name: "Székesfehérvár", slug: "szekesfehervar" },
      { name: "Szombathely", slug: "szombathely" },
      { name: "Szolnok", slug: "szolnok" },
      { name: "Tatabánya", slug: "tatabanya" },
      { name: "Kaposvár", slug: "kaposvar" },
      { name: "Eger", slug: "eger" },
      { name: "Veszprém", slug: "veszprem" }
    ]
  },
  {
    name: "Czech Republic",
    code: "cz",
    topCities: [
      { name: "Prague", slug: "prague" },
      { name: "Brno", slug: "brno" },
      { name: "Ostrava", slug: "ostrava" },
      { name: "Pilsen", slug: "pilsen" },
      { name: "Liberec", slug: "liberec" },
      { name: "Olomouc", slug: "olomouc" },
      { name: "České Budějovice", slug: "ceske-budejovice" },
      { name: "Hradec Králové", slug: "hradec-kralove" },
      { name: "Ústí nad Labem", slug: "usti-nad-labem" },
      { name: "Pardubice", slug: "pardubice" },
      { name: "Zlín", slug: "zlin" },
      { name: "Havířov", slug: "havirov" },
      { name: "Kladno", slug: "kladno" },
      { name: "Karlovy Vary", slug: "karlovy-vary" },
      { name: "Jihlava", slug: "jihlava" }
    ]
  },
  {
    name: "Singapore",
    code: "sg",
    topCities: [
      { name: "Singapore", slug: "singapore" },
      { name: "Jurong East", slug: "jurong-east" },
      { name: "Woodlands", slug: "woodlands" },
      { name: "Tampines", slug: "tampines" },
      { name: "Pasir Ris", slug: "pasir-ris" },
      { name: "Changi", slug: "changi" },
      { name: "Sentosa", slug: "sentosa" },
      { name: "Punggol", slug: "punggol" },
      { name: "Ang Mo Kio", slug: "ang-mo-kio" },
      { name: "Orchard", slug: "orchard" },
      { name: "Marina Bay", slug: "marina-bay" },
      { name: "Bukit Timah", slug: "bukit-timah" },
      { name: "Yishun", slug: "yishun" },
      { name: "Bukit Merah", slug: "bukit-merah" },
      { name: "Serangoon", slug: "serangoon" }
    ]
  },
  {
    name: "New Zealand",
    code: "nz",
    topCities: [
      { name: "Auckland", slug: "auckland" },
      { name: "Wellington", slug: "wellington" },
      { name: "Christchurch", slug: "christchurch" },
      { name: "Hamilton", slug: "hamilton-nz" },
      { name: "Tauranga", slug: "tauranga" },
      { name: "Dunedin", slug: "dunedin" },
      { name: "Napier", slug: "napier" },
      { name: "Nelson", slug: "nelson" },
      { name: "Queenstown", slug: "queenstown" },
      { name: "Rotorua", slug: "rotorua" },
      { name: "Palmerston North", slug: "palmerston-north" },
      { name: "New Plymouth", slug: "new-plymouth" },
      { name: "Whangarei", slug: "whangarei" },
      { name: "Invercargill", slug: "invercargill" },
      { name: "Wanaka", slug: "wanaka" }
    ]
  },
  {
    name: "United Arab Emirates",
    code: "ae",
    topCities: [
      { name: "Dubai", slug: "dubai" },
      { name: "Abu Dhabi", slug: "abu-dhabi" },
      { name: "Sharjah", slug: "sharjah" },
      { name: "Al Ain", slug: "al-ain" },
      { name: "Ajman", slug: "ajman" },
      { name: "Ras Al Khaimah", slug: "ras-al-khaimah" },
      { name: "Fujairah", slug: "fujairah" },
      { name: "Umm Al Quwain", slug: "umm-al-quwain" },
      { name: "Dibba Al-Fujairah", slug: "dibba-al-fujairah" },
      { name: "Khor Fakkan", slug: "khor-fakkan" },
      { name: "Kalba", slug: "kalba" },
      { name: "Madinat Zayed", slug: "madinat-zayed" },
      { name: "Liwa Oasis", slug: "liwa-oasis" },
      { name: "Ruwais", slug: "ruwais" },
      { name: "Jebel Ali", slug: "jebel-ali" }
    ]
  },
  {
    name: "Thailand",
    code: "th",
    topCities: [
      { name: "Bangkok", slug: "bangkok" },
      { name: "Chiang Mai", slug: "chiang-mai" },
      { name: "Phuket", slug: "phuket" },
      { name: "Pattaya", slug: "pattaya" },
      { name: "Hat Yai", slug: "hat-yai" },
      { name: "Krabi", slug: "krabi" },
      { name: "Hua Hin", slug: "hua-hin" },
      { name: "Ayutthaya", slug: "ayutthaya" },
      { name: "Koh Samui", slug: "koh-samui" },
      { name: "Chiang Rai", slug: "chiang-rai" },
      { name: "Udon Thani", slug: "udon-thani" },
      { name: "Khon Kaen", slug: "khon-kaen" },
      { name: "Nakhon Ratchasima", slug: "nakhon-ratchasima" },
      { name: "Surat Thani", slug: "surat-thani" },
      { name: "Pai", slug: "pai" }
    ]
  },
  {
    name: "Malaysia",
    code: "my",
    topCities: [
      { name: "Kuala Lumpur", slug: "kuala-lumpur" },
      { name: "Penang", slug: "penang" },
      { name: "Johor Bahru", slug: "johor-bahru" },
      { name: "Ipoh", slug: "ipoh" },
      { name: "Kota Kinabalu", slug: "kota-kinabalu" },
      { name: "Kuching", slug: "kuching" },
      { name: "Melaka", slug: "melaka" },
      { name: "Shah Alam", slug: "shah-alam" },
      { name: "Petaling Jaya", slug: "petaling-jaya" },
      { name: "Kota Bharu", slug: "kota-bharu" },
      { name: "Kuantan", slug: "kuantan" },
      { name: "Alor Setar", slug: "alor-setar" },
      { name: "Miri", slug: "miri" },
      { name: "Sandakan", slug: "sandakan" },
      { name: "Seremban", slug: "seremban" }
    ]
  },
  {
    name: "Vietnam",
    code: "vn",
    topCities: [
      { name: "Ho Chi Minh City", slug: "ho-chi-minh-city" },
      { name: "Hanoi", slug: "hanoi" },
      { name: "Da Nang", slug: "da-nang" },
      { name: "Nha Trang", slug: "nha-trang" },
      { name: "Hoi An", slug: "hoi-an" },
      { name: "Haiphong", slug: "haiphong" },
      { name: "Can Tho", slug: "can-tho" },
      { name: "Hue", slug: "hue" },
      { name: "Vung Tau", slug: "vung-tau" },
      { name: "Quy Nhon", slug: "quy-nhon" },
      { name: "Buon Ma Thuot", slug: "buon-ma-thuot" },
      { name: "Ha Long", slug: "ha-long" },
      { name: "Dalat", slug: "dalat" },
      { name: "Vinh", slug: "vinh" },
      { name: "Phan Thiet", slug: "phan-thiet" }
    ]
  },
  {
    name: "Philippines",
    code: "ph",
    topCities: [
      { name: "Manila", slug: "manila" },
      { name: "Quezon City", slug: "quezon-city" },
      { name: "Cebu City", slug: "cebu-city" },
      { name: "Davao City", slug: "davao-city" },
      { name: "Makati", slug: "makati" },
      { name: "Taguig", slug: "taguig" },
      { name: "Pasig", slug: "pasig" },
      { name: "Baguio", slug: "baguio" },
      { name: "Iloilo City", slug: "iloilo-city" },
      { name: "Bacolod", slug: "bacolod" },
      { name: "Angeles City", slug: "angeles-city" },
      { name: "Cagayan de Oro", slug: "cagayan-de-oro" },
      { name: "Zamboanga City", slug: "zamboanga-city" },
      { name: "General Santos", slug: "general-santos" },
      { name: "Lapu-Lapu City", slug: "lapu-lapu-city" }
    ]
  },
  {
    name: "Egypt",
    code: "eg",
    topCities: [
      { name: "Cairo", slug: "cairo" },
      { name: "Alexandria", slug: "alexandria" },
      { name: "Giza", slug: "giza" },
      { name: "Luxor", slug: "luxor" },
      { name: "Aswan", slug: "aswan" },
      { name: "Hurghada", slug: "hurghada" },
      { name: "Sharm El Sheikh", slug: "sharm-el-sheikh" },
      { name: "Port Said", slug: "port-said" },
      { name: "Suez", slug: "suez" },
      { name: "Tanta", slug: "tanta" },
      { name: "Mansoura", slug: "mansoura" },
      { name: "Ismailia", slug: "ismailia" },
      { name: "Faiyum", slug: "faiyum" },
      { name: "Zagazig", slug: "zagazig" },
      { name: "Damietta", slug: "damietta" }
    ]
  },
  {
    name: "South Africa",
    code: "za",
    topCities: [
      { name: "Johannesburg", slug: "johannesburg" },
      { name: "Cape Town", slug: "cape-town" },
      { name: "Durban", slug: "durban" },
      { name: "Pretoria", slug: "pretoria" },
      { name: "Port Elizabeth", slug: "port-elizabeth" },
      { name: "Bloemfontein", slug: "bloemfontein" },
      { name: "Nelspruit", slug: "nelspruit" },
      { name: "Kimberley", slug: "kimberley" },
      { name: "Polokwane", slug: "polokwane" },
      { name: "Pietermaritzburg", slug: "pietermaritzburg" },
      { name: "East London", slug: "east-london" },
      { name: "George", slug: "george" },
      { name: "Stellenbosch", slug: "stellenbosch" },
      { name: "Rustenburg", slug: "rustenburg" },
      { name: "Potchefstroom", slug: "potchefstroom" }
    ]
  },
  {
    name: "Israel",
    code: "il",
    topCities: [
      { name: "Jerusalem", slug: "jerusalem" },
      { name: "Tel Aviv", slug: "tel-aviv" },
      { name: "Haifa", slug: "haifa" },
      { name: "Rishon LeZion", slug: "rishon-lezion" },
      { name: "Petah Tikva", slug: "petah-tikva" },
      { name: "Ashdod", slug: "ashdod" },
      { name: "Netanya", slug: "netanya" },
      { name: "Beer Sheva", slug: "beer-sheva" },
      { name: "Holon", slug: "holon" },
      { name: "Bnei Brak", slug: "bnei-brak" },
      { name: "Ramat Gan", slug: "ramat-gan" },
      { name: "Rehovot", slug: "rehovot" },
      { name: "Herzliya", slug: "herzliya" },
      { name: "Kfar Saba", slug: "kfar-saba" },
      { name: "Eilat", slug: "eilat" }
    ]
  },
  {
    name: "Chile",
    code: "cl",
    topCities: [
      { name: "Santiago", slug: "santiago" },
      { name: "Valparaíso", slug: "valparaiso" },
      { name: "Viña del Mar", slug: "vina-del-mar" },
      { name: "Concepción", slug: "concepcion" },
      { name: "La Serena", slug: "la-serena" },
      { name: "Antofagasta", slug: "antofagasta" },
      { name: "Temuco", slug: "temuco" },
      { name: "Rancagua", slug: "rancagua" },
      { name: "Arica", slug: "arica" },
      { name: "Puerto Montt", slug: "puerto-montt" },
      { name: "Talca", slug: "talca" },
      { name: "Iquique", slug: "iquique" },
      { name: "Chillán", slug: "chillan" },
      { name: "Calama", slug: "calama" },
      { name: "Punta Arenas", slug: "punta-arenas" }
    ]
  },
  {
    name: "Colombia",
    code: "co",
    topCities: [
      { name: "Bogotá", slug: "bogota" },
      { name: "Medellín", slug: "medellin" },
      { name: "Cali", slug: "cali" },
      { name: "Barranquilla", slug: "barranquilla" },
      { name: "Cartagena", slug: "cartagena" },
      { name: "Cúcuta", slug: "cucuta" },
      { name: "Bucaramanga", slug: "bucaramanga" },
      { name: "Pereira", slug: "pereira" },
      { name: "Santa Marta", slug: "santa-marta" },
      { name: "Manizales", slug: "manizales" },
      { name: "Ibagué", slug: "ibague" },
      { name: "Pasto", slug: "pasto" },
      { name: "Neiva", slug: "neiva" },
      { name: "Armenia", slug: "armenia" },
      { name: "Villavicencio", slug: "villavicencio" }
    ]
  },
  {
    name: "Peru",
    code: "pe",
    topCities: [
      { name: "Lima", slug: "lima" },
      { name: "Arequipa", slug: "arequipa" },
      { name: "Trujillo", slug: "trujillo" },
      { name: "Cusco", slug: "cusco" },
      { name: "Chiclayo", slug: "chiclayo" },
      { name: "Piura", slug: "piura" },
      { name: "Iquitos", slug: "iquitos" },
      { name: "Huancayo", slug: "huancayo" },
      { name: "Tacna", slug: "tacna" },
      { name: "Pucallpa", slug: "pucallpa" },
      { name: "Chimbote", slug: "chimbote" },
      { name: "Ayacucho", slug: "ayacucho" },
      { name: "Cajamarca", slug: "cajamarca" },
      { name: "Juliaca", slug: "juliaca" },
      { name: "Ica", slug: "ica" }
    ]
  },
  {
    name: "Saudi Arabia",
    code: "sa",
    topCities: [
      { name: "Riyadh", slug: "riyadh" },
      { name: "Jeddah", slug: "jeddah" },
      { name: "Mecca", slug: "mecca" },
      { name: "Medina", slug: "medina" },
      { name: "Dammam", slug: "dammam" },
      { name: "Taif", slug: "taif" },
      { name: "Tabuk", slug: "tabuk" },
      { name: "Buraidah", slug: "buraidah" },
      { name: "Khobar", slug: "khobar" },
      { name: "Abha", slug: "abha" },
      { name: "Najran", slug: "najran" },
      { name: "Jubail", slug: "jubail" },
      { name: "Hail", slug: "hail" },
      { name: "Khamis Mushait", slug: "khamis-mushait" },
      { name: "Yanbu", slug: "yanbu" }
    ]
  },
  {
    name: "Qatar",
    code: "qa",
    topCities: [
      { name: "Doha", slug: "doha" },
      { name: "Al Wakrah", slug: "al-wakrah" },
      { name: "Al Khor", slug: "al-khor" },
      { name: "Al Rayyan", slug: "al-rayyan" },
      { name: "Mesaieed", slug: "mesaieed" },
      { name: "Dukhan", slug: "dukhan" },
      { name: "Al Shahaniya", slug: "al-shahaniya" },
      { name: "Umm Salal", slug: "umm-salal" },
      { name: "Al Wukair", slug: "al-wukair" },
      { name: "Lusail", slug: "lusail" },
      { name: "Al Gharrafa", slug: "al-gharrafa" },
      { name: "Al Thakhira", slug: "al-thakhira" },
      { name: "Madinat ash Shamal", slug: "madinat-ash-shamal" },
      { name: "Abu Samra", slug: "abu-samra" },
      { name: "Al Ruwais", slug: "al-ruwais" }
    ]
  },
  {
    name: "Morocco",
    code: "ma",
    topCities: [
      { name: "Casablanca", slug: "casablanca" },
      { name: "Rabat", slug: "rabat" },
      { name: "Marrakesh", slug: "marrakesh" },
      { name: "Fes", slug: "fes" },
      { name: "Tangier", slug: "tangier" },
      { name: "Agadir", slug: "agadir" },
      { name: "Meknes", slug: "meknes" },
      { name: "Oujda", slug: "oujda" },
      { name: "Kenitra", slug: "kenitra" },
      { name: "Tetouan", slug: "tetouan" },
      { name: "Safi", slug: "safi" },
      { name: "Mohammedia", slug: "mohammedia" },
      { name: "El Jadida", slug: "el-jadida" },
      { name: "Essaouira", slug: "essaouira" },
      { name: "Chefchaouen", slug: "chefchaouen" }
    ]
  },
  {
    name: "Bangladesh",
    code: "bd",
    topCities: [
      { name: "Dhaka", slug: "dhaka" },
      { name: "Chittagong", slug: "chittagong" },
      { name: "Khulna", slug: "khulna" },
      { name: "Rajshahi", slug: "rajshahi" },
      { name: "Sylhet", slug: "sylhet" },
      { name: "Barisal", slug: "barisal" },
      { name: "Rangpur", slug: "rangpur" },
      { name: "Comilla", slug: "comilla" },
      { name: "Narayanganj", slug: "narayanganj" },
      { name: "Mymensingh", slug: "mymensingh" },
      { name: "Jessore", slug: "jessore" },
      { name: "Dinajpur", slug: "dinajpur" },
      { name: "Cox's Bazar", slug: "coxs-bazar" },
      { name: "Bogra", slug: "bogra" },
      { name: "Tangail", slug: "tangail" }
    ]
  },
  {
    name: "Pakistan",
    code: "pk",
    topCities: [
      { name: "Karachi", slug: "karachi" },
      { name: "Lahore", slug: "lahore" },
      { name: "Islamabad", slug: "islamabad" },
      { name: "Rawalpindi", slug: "rawalpindi" },
      { name: "Faisalabad", slug: "faisalabad" },
      { name: "Multan", slug: "multan" },
      { name: "Peshawar", slug: "peshawar" },
      { name: "Quetta", slug: "quetta" },
      { name: "Sialkot", slug: "sialkot" },
      { name: "Gujranwala", slug: "gujranwala" },
      { name: "Hyderabad", slug: "hyderabad-pk" },
      { name: "Abbottabad", slug: "abbottabad" },
      { name: "Sargodha", slug: "sargodha" },
      { name: "Bahawalpur", slug: "bahawalpur" },
      { name: "Sukkur", slug: "sukkur" }
    ]
  },
  {
    name: "Nigeria",
    code: "ng",
    topCities: [
      { name: "Lagos", slug: "lagos-ng" },
      { name: "Abuja", slug: "abuja" },
      { name: "Kano", slug: "kano" },
      { name: "Port Harcourt", slug: "port-harcourt" },
      { name: "Ibadan", slug: "ibadan" },
      { name: "Benin City", slug: "benin-city" },
      { name: "Kaduna", slug: "kaduna" },
      { name: "Enugu", slug: "enugu" },
      { name: "Calabar", slug: "calabar" },
      { name: "Aba", slug: "aba" },
      { name: "Jos", slug: "jos" },
      { name: "Ilorin", slug: "ilorin" },
      { name: "Onitsha", slug: "onitsha" },
      { name: "Warri", slug: "warri" },
      { name: "Abeokuta", slug: "abeokuta" }
    ]
  },
  {
    name: "Kenya",
    code: "ke",
    topCities: [
      { name: "Nairobi", slug: "nairobi" },
      { name: "Mombasa", slug: "mombasa" },
      { name: "Kisumu", slug: "kisumu" },
      { name: "Nakuru", slug: "nakuru" },
      { name: "Eldoret", slug: "eldoret" },
      { name: "Malindi", slug: "malindi" },
      { name: "Kitale", slug: "kitale" },
      { name: "Thika", slug: "thika" },
      { name: "Garissa", slug: "garissa" },
      { name: "Kakamega", slug: "kakamega" },
      { name: "Nyeri", slug: "nyeri" },
      { name: "Machakos", slug: "machakos" },
      { name: "Lamu", slug: "lamu" },
      { name: "Kericho", slug: "kericho" },
      { name: "Naivasha", slug: "naivasha" }
    ]
  },
  {
    name: "Ghana",
    code: "gh",
    topCities: [
      { name: "Accra", slug: "accra" },
      { name: "Kumasi", slug: "kumasi" },
      { name: "Tamale", slug: "tamale" },
      { name: "Sekondi-Takoradi", slug: "sekondi-takoradi" },
      { name: "Cape Coast", slug: "cape-coast" },
      { name: "Tema", slug: "tema" },
      { name: "Koforidua", slug: "koforidua" },
      { name: "Sunyani", slug: "sunyani" },
      { name: "Ho", slug: "ho" },
      { name: "Obuasi", slug: "obuasi" },
      { name: "Teshie", slug: "teshie" },
      { name: "Techiman", slug: "techiman" },
      { name: "Wa", slug: "wa" },
      { name: "Bolgatanga", slug: "bolgatanga" },
      { name: "Nkawkaw", slug: "nkawkaw" }
    ]
  },
  {
    name: "Ukraine",
    code: "ua",
    topCities: [
      { name: "Kyiv", slug: "kyiv" },
      { name: "Kharkiv", slug: "kharkiv" },
      { name: "Odesa", slug: "odesa" },
      { name: "Dnipro", slug: "dnipro" },
      { name: "Lviv", slug: "lviv" },
      { name: "Zaporizhzhia", slug: "zaporizhzhia" },
      { name: "Vinnytsia", slug: "vinnytsia" },
      { name: "Chernihiv", slug: "chernihiv" },
      { name: "Mykolaiv", slug: "mykolaiv" },
      { name: "Cherkasy", slug: "cherkasy" },
      { name: "Poltava", slug: "poltava" },
      { name: "Ivano-Frankivsk", slug: "ivano-frankivsk" },
      { name: "Uzhhorod", slug: "uzhhorod" },
      { name: "Ternopil", slug: "ternopil" },
      { name: "Chernivtsi", slug: "chernivtsi" }
    ]
  },
  {
    name: "Romania",
    code: "ro",
    topCities: [
      { name: "Bucharest", slug: "bucharest" },
      { name: "Cluj-Napoca", slug: "cluj-napoca" },
      { name: "Timișoara", slug: "timisoara" },
      { name: "Iași", slug: "iasi" },
      { name: "Constanța", slug: "constanta" },
      { name: "Craiova", slug: "craiova" },
      { name: "Brașov", slug: "brasov" },
      { name: "Galați", slug: "galati" },
      { name: "Ploiești", slug: "ploiesti" },
      { name: "Oradea", slug: "oradea" },
      { name: "Brăila", slug: "braila" },
      { name: "Arad", slug: "arad" },
      { name: "Pitești", slug: "pitesti" },
      { name: "Sibiu", slug: "sibiu" },
      { name: "Bacău", slug: "bacau" }
    ]
  },
  {
    name: "Bulgaria",
    code: "bg",
    topCities: [
      { name: "Sofia", slug: "sofia" },
      { name: "Plovdiv", slug: "plovdiv" },
      { name: "Varna", slug: "varna" },
      { name: "Burgas", slug: "burgas" },
      { name: "Ruse", slug: "ruse" },
      { name: "Stara Zagora", slug: "stara-zagora" },
      { name: "Pleven", slug: "pleven" },
      { name: "Sliven", slug: "sliven" },
      { name: "Dobrich", slug: "dobrich" },
      { name: "Shumen", slug: "shumen" },
      { name: "Pernik", slug: "pernik" },
      { name: "Haskovo", slug: "haskovo" },
      { name: "Yambol", slug: "yambol" },
      { name: "Pazardzhik", slug: "pazardzhik" },
      { name: "Blagoevgrad", slug: "blagoevgrad" }
    ]
  },
  {
    name: "Croatia",
    code: "hr",
    topCities: [
      { name: "Zagreb", slug: "zagreb" },
      { name: "Split", slug: "split" },
      { name: "Rijeka", slug: "rijeka" },
      { name: "Osijek", slug: "osijek" },
      { name: "Zadar", slug: "zadar" },
      { name: "Pula", slug: "pula" },
      { name: "Dubrovnik", slug: "dubrovnik" },
      { name: "Varaždin", slug: "varazdin" },
      { name: "Šibenik", slug: "sibenik" },
      { name: "Karlovac", slug: "karlovac" },
      { name: "Slavonski Brod", slug: "slavonski-brod" },
      { name: "Rovinj", slug: "rovinj" },
      { name: "Makarska", slug: "makarska" },
      { name: "Trogir", slug: "trogir" },
      { name: "Vukovar", slug: "vukovar" }
    ]
  },
  {
    name: "Hong Kong",
    code: "hk",
    topCities: [
      { name: "Hong Kong", slug: "hong-kong" },
      { name: "Kowloon", slug: "kowloon" },
      { name: "Tsuen Wan", slug: "tsuen-wan" },
      { name: "Sha Tin", slug: "sha-tin" },
      { name: "Tuen Mun", slug: "tuen-mun" },
      { name: "Yuen Long", slug: "yuen-long" },
      { name: "Tai Po", slug: "tai-po" },
      { name: "Sheung Shui", slug: "sheung-shui" },
      { name: "Fanling", slug: "fanling" },
      { name: "Sai Kung", slug: "sai-kung" },
      { name: "Causeway Bay", slug: "causeway-bay" },
      { name: "Wan Chai", slug: "wan-chai" },
      { name: "Central", slug: "central" },
      { name: "Aberdeen", slug: "aberdeen-hk" },
      { name: "Mong Kok", slug: "mong-kok" }
    ]
  },
  {
    name: "Taiwan",
    code: "tw",
    topCities: [
      { name: "Taipei", slug: "taipei" },
      { name: "Kaohsiung", slug: "kaohsiung" },
      { name: "Taichung", slug: "taichung" },
      { name: "Tainan", slug: "tainan" },
      { name: "Hsinchu", slug: "hsinchu" },
      { name: "Keelung", slug: "keelung" },
      { name: "Taoyuan", slug: "taoyuan" },
      { name: "Chiayi", slug: "chiayi" },
      { name: "Changhua", slug: "changhua" },
      { name: "Pingtung", slug: "pingtung" },
      { name: "Yilan", slug: "yilan" },
      { name: "Taitung", slug: "taitung" },
      { name: "Hualien", slug: "hualien" },
      { name: "Magong", slug: "magong" },
      { name: "Jincheng", slug: "jincheng" }
    ]
  }
];
